import { pageInfo, addSubmit, detailInfo, editSubmit, deleteBatch } from './../api';
import { getDcNoList } from '../../../../api/index'
const rejectEmail = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addSubmitObj: null,
    detailInfoObj: null,
    editSubmitObj: null,
    deleteBatchObj: null,
    dcNoListData: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    ADD_SUBMIT(state, data) {
      state.addSubmitObj = data;
    },
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data.obj || {};
    },
    EDIT_SUBMIT(state, data) {
      state.editSubmitObj = data;
    },
    DELETE_BATCH(state, data) {
      state.deleteBatchObj = data;
    },
    GET_DCNO_LIST(state, data) {
      state.dcNoListData = data;
    }
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async addSubmit({ commit }, obj) {
      let resp = await addSubmit(obj);
      commit('ADD_SUBMIT', resp);
    },
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async editSubmit({ commit }, obj) {
      let resp = await editSubmit(obj);
      commit('EDIT_SUBMIT', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH', resp);
    },
    /**
     * 获取dcNo下拉列表
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDcNoList({ commit }, obj) {
      let resp = await getDcNoList(obj);
      commit('GET_DCNO_LIST', resp);
    }
  }
}
export default rejectEmail



// WEBPACK FOOTER //
// ./src/page/md/rejectEmail/store/rejectEmail.store.js